export const safetyArticles = {
  "driving-in-rain": {
    title: "How to drive in the rain",
    subtitle: "Mastering Wet Roads & Preventing Hydroplaning",
    videoUrl: "https://www.youtube.com/embed/CnBLsR5WsN0",
    content: []
  },
  "driving-in-snow": {
    title: "How to drive in snow",
    subtitle: "Winter Driving Essentials and Traction Control",
    videoUrl: "https://www.youtube.com/embed/xN1WNOugM6A",
    content: []
  },
  "driving-in-fog": {
    title: "How to drive in Fog",
    subtitle: "Navigating Low Visibility Conditions",
    videoUrl: "https://www.youtube.com/embed/SKHvDfVHsWc",
    content: []
  },
  "driving-on-ice": {
    title: "How to drive in ice",
    subtitle: "Handling Black Ice and Freezing Conditions",
    videoUrl: "https://www.youtube.com/embed/rYpgyNlF6cM",
    content: []
  },
  "driving-roundabouts": {
    title: "Driving Roundabouts",
    subtitle: "Safety and Rules for Circular Intersections",
    videoUrl: "https://www.youtube.com/embed/16wi9uVq-SQ",
    content: []
  },
  "driving-blizzard": {
    title: "How to drive in a blizzard",
    subtitle: "Survival in Extreme Winter Weather",
    videoUrl: "https://www.youtube.com/embed/ohX0YHr7Xjw",
    content: []
  }
};